import { useMemo } from 'react';
// hooks
import { useAuthContext } from '../../../auth/useAuthContext';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
//
import navConfig from './config-navigation';

// ----------------------------------------------------------------------

const PART_ORDERS_ITEM = {
  title: 'Part Orders',
  path: PATH_DASHBOARD.customerservice.partorderlist,
};

// Returns a copy of navConfig with any per-user items added. navConfig itself is
// never modified, so rendering several navs (or re-rendering) can't duplicate
// entries, and nothing carries over from one login to the next.
export function buildNavConfig({ canOrderParts }) {
  if (!canOrderParts) return navConfig;

  return navConfig.map((group, groupIndex) => {
    if (groupIndex !== 0) return group;

    return {
      ...group,
      items: group.items.map((item) => {
        if (item.title !== 'Customer Service' || !item.children) return item;

        return { ...item, children: [PART_ORDERS_ITEM, ...item.children] };
      }),
    };
  });
}

export default function useNavConfig() {
  const { user } = useAuthContext();

  // noorderforyou comes from Epicor (Noorderforyou_c) and opts a dealer OUT of
  // online part ordering, so only a true value hides the nav.
  const canOrderParts = Boolean(user) && !user.noorderforyou;

  return useMemo(() => buildNavConfig({ canOrderParts }), [canOrderParts]);
}
